import { Text, VStack } from '@chakra-ui/react';

interface ICalendarPageProps {
	bg: string;
	color: string;
	day: string;
	month: string;
}

export const CalendarPage: React.FunctionComponent<ICalendarPageProps> = ({ bg, color, day, month }) => {
	return (
		<VStack className='calendar-page' bg={bg} color={color} borderRadius='sm' p={3}>
			<Text as='span' className='calendar-page__day'>
				{day}
			</Text>
			<Text as='span' className='calendar-page__month'>
				{month}
			</Text>
		</VStack>
	);
};
